jQuery("select._table").change(function() {
  var val = jQuery("select._table option:selected").val();
  if (val == "select") return;
  jQuery(".table-container").fadeOut();
  jQuery("section#" + val).fadeIn();
});

jQuery("select._seminar").change(function() {
  var val = jQuery("select._seminar option:selected").val();
  if (val == "select") return;
  jQuery("div.seminar-list").fadeOut();
  jQuery("div.seminar-list#" + val).fadeIn();
});
